import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const OperatorRegisterPendingPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const returnTo = location.state?.from?.pathname || '/ddp/create';

  return (
    <div className="max-w-lg mx-auto mt-8 p-4 sm:p-6">
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="px-6 py-5 border-b border-gray-100">
          <h2 className="text-xl font-semibold text-gray-900">{t('operator.pendingTitle')}</h2>
        </div>
        <div className="px-6 py-5 space-y-4">
          <p className="text-amber-700">{t('operator.registerSuccess')}</p>
          <p className="text-sm text-gray-600">{t('operator.pendingManagerApprovalMessage')}</p>
          <p className="text-sm text-gray-600">{t('operator.pendingNotificationMessage')}</p>
          <div>
            <Link
              to="/login"
              state={{ from: { pathname: returnTo } }}
              className="inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
            >
              {t('login.signIn')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OperatorRegisterPendingPage;
